import React, { useCallback,useEffect, useState } from 'react';
import {
  Box, VStack, Text, IconButton, useColorModeValue, HStack, useToast, Flex
} from '@chakra-ui/react';
import { ViewIcon, DownloadIcon, DeleteIcon } from '@chakra-ui/icons';

const UserOutputs = ({ userId }) => {
  const [files, setFiles] = useState([]);
  const [selectedFileUrl, setSelectedFileUrl] = useState('');
  const [selectedFileType, setSelectedFileType] = useState('');
  const contentBgColor = useColorModeValue('brand.50', 'brand.900');
  const toast = useToast();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchFiles();
  }, [userId]);

  const fetchFiles = async () => {
    try {
      const response = await fetch(`${backendUrl}/outputs/${userId}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      const filteredFiles = data.files.filter(file => file.match(/\.(pdf|txt|md)$/)); // Filter files with extensions
      setFiles(filteredFiles.sort()); // Sort files alphabetically
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Could not fetch files.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  

  const handleViewFile = (file, fileType) => {
    setSelectedFileUrl(`${backendUrl}/outputs/${userId}/${file}`);
    setSelectedFileType(fileType);
  };


  

  const handleDeleteFile = async (file) => {
    console.log('Deleting file', file)
    try {
      const response = await fetch(`${backendUrl}/outputs/${userId}/${file}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Failed to delete file');
      fetchFiles(); // Refresh the files list
      toast({
        title: 'File Deleted',
        description: `Successfully deleted ${file}`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Deletion Failed',
        description: `Could not delete ${file}`,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <VStack spacing={4} flex="1" bg={contentBgColor} p={4} borderRadius="md">
        {files.map((file, index) => (
          <HStack key={index} width="100%">
            <Text flex="1">{file}</Text>
            <IconButton
              icon={<ViewIcon />}
              onClick={() => handleViewFile(file, file.split('.').pop())}
              aria-label="View file"
            />
            <IconButton
              icon={<DownloadIcon />}
              onClick={() => window.open(`${backendUrl}/outputs/${userId}/${file}`)}
              aria-label="Download file"
            />
            <IconButton
              icon={<DeleteIcon />}
              onClick={() => handleDeleteFile(file)}
              aria-label="Delete file"
              size="sm"
              colorScheme="red"
            />
          </HStack>
        ))}
      </VStack>
      {selectedFileUrl && (
        <Box flex="2" p={4} borderLeft="1px" borderColor="gray.200">
          {selectedFileType === 'pdf' ? (
            <object data={selectedFileUrl} type="application/pdf" width="100%" height="500px">
              <p>No PDF viewer available</p>
            </object>
          ) : (
            <iframe src={selectedFileUrl} frameBorder="0" width="100%" height="500px" style={{ border: 'none' }}></iframe>
          )}
        </Box>
      )}
    </Flex>
  );
};

export default UserOutputs;
